import React from 'react';

class ScoreDisplay extends React.Component {
  render() {
    return (
      <div>
        <h1 className="scoreDisplay">Total Score</h1><h1 className="score">{this.props.totalScore.toLocaleString('en')}</h1>
      </div>
    )
  }
}

export default ScoreDisplay;



// WEBPACK FOOTER //
// ./src/Components/ScoreDisplay/ScoreDisplay.js